export const STAFF_ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  BARBER: 'barber',
};

export const DEFAULT_NOTIFICATION_ROLES = [
  STAFF_ROLES.OWNER,
  STAFF_ROLES.ADMIN,
];

export const ADMIN_ROLES = [
  STAFF_ROLES.OWNER,
  STAFF_ROLES.ADMIN,
];

